import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import TopicDetail from "@/pages/TopicDetail";
import About from "@/pages/About";
import News from "@/pages/News";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";
import ScrollToTop from "@/components/ScrollToTop";
import CookieBanner from "@/components/CookieBanner";
import { NotificationPrompt } from "@/components/NotificationPrompt";

const PUBLIC_TOAST_STYLE = {
        background: "var(--paper-2)",
        border: "1px solid var(--line-strong)",
        color: "var(--ink)",
        fontFamily: "JetBrains Mono, monospace",
        fontSize: 12,
};

// O Toaster renderiza num portal fora do scope .admin-ui, por isso o estilo
// admin usa valores literais em vez de tokens.
const ADMIN_TOAST_STYLE = {
        background: "#ffffff",
        border: "1px solid #cfd6e0",
        borderRadius: 10,
        boxShadow: "0 4px 16px rgba(16, 24, 40, 0.1)",
        color: "#16181d",
        fontFamily: "Inter, -apple-system, sans-serif",
        fontSize: 13,
};

function AppChrome() {
        const { pathname } = useLocation();
        const isAdmin = pathname.startsWith("/admin");

        useEffect(() => {
                document.documentElement.classList.toggle("admin-route", isAdmin);
                return () => document.documentElement.classList.remove("admin-route");
        }, [isAdmin]);

        return (
                <>
                        {!isAdmin && <div className="texture-overlay"></div>}
                        <a
                                href="#conteudo"
                                className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200] focus:bg-[var(--ink)] focus:px-4 focus:py-3 focus:text-[var(--bg-deep)] focus:font-mono focus:text-sm"
                        >
                                Saltar para conteúdo
                        </a>
                        <ScrollToTop />
                        <Toaster
                                position="top-right"
                                toastOptions={{
                                        style: isAdmin ? ADMIN_TOAST_STYLE : PUBLIC_TOAST_STYLE,
                                }}
                        />
                        {!isAdmin && <Header />}
                        <div id="conteudo" tabIndex={-1}>
                                <Routes>
                                        <Route path="/" element={<Home />} />
                                        <Route path="/topico/:slug" element={<TopicDetail />} />
                                        <Route path="/noticias" element={<News />} />
                                        <Route path="/sobre" element={<About />} />
                                        <Route path="/admin" element={<AdminLogin />} />
                                        <Route path="/admin/painel" element={<AdminPanel />} />
                                </Routes>
                        </div>
                        {!isAdmin && <Footer />}
                        {!isAdmin && <NotificationPrompt />}
                        {!isAdmin && <CookieBanner />}
                </>
        );
}

function App() {
        return (
                <div className="App">
                        <BrowserRouter>
                                <AppChrome />
                        </BrowserRouter>
                </div>
        );
}

export default App;
